import {Component, OnDestroy, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {App, AppId} from '../../../../../shared/models/app';
import {Subscription} from 'rxjs';
import {Store} from '@ngrx/store';
import {AppState} from '../../../../../app/app.state';
import {AppsService} from '../../../../../core/services/apps.service';
import {AppsState} from '../../../../../core/state/apps.state';
import {AppGlobalSettingsComponent} from '../../../../components/app-global-settings/app-global-settings.component';

@Component({
  selector: 'motn-app-settings-mosaic',
  templateUrl: './app-settings-mosaic.component.html',
  styleUrls: ['./app-settings-mosaic.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    AppGlobalSettingsComponent,
  ],
})
export class AppSettingsMosaicComponent implements OnInit, OnDestroy {
  app: App;

  private appsSub: Subscription;


  constructor(
    private store: Store<AppState>,
    private appsService: AppsService,
  ) {
  }


  ngOnInit(): void {
    this.appsSub = this.store.select('apps').subscribe(
      (data: AppsState) => {
        this.app = data.apps.find((a) => {
          return a.ID === this.appsService.currentAppId;
        });
      },
    );

    this.appsService.fetchApp(this.appsService.currentAppId);
  }


  ngOnDestroy() {
    this.appsSub?.unsubscribe();
  }
}
